export const commas = (num) => {
    return num.toLocaleString("en");
}